import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from 'src/data-store/data.service';
import { NewInvestmentRoute, LOGIN_REDIRECT_PATH, ThematicStrategiesRoute, EditInvestmentRoute } from 'src/models/routes.model';

@Injectable({
  providedIn: 'root'
})
export class NewInvestmentProgressService {
  private router = inject(Router);
  private dataService = inject(DataService);

  private newInvestmentProgressUrls: string[] = [
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.INVESTMENT_GOAL}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.INVESTMENT_TYPE}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.NEW_INVESTMENT_SETTINGS}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.INSTRUMENTS_SELECT}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.INSTRUMENTS_WEIGHTS}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${ThematicStrategiesRoute.THEMATIC_STRATEGIES}`,
    `${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.SUCCESS}`,
  ];

  private editInvestmentProgressUrls: string[] = [
    `${EditInvestmentRoute.EDIT_INVESTMENT}/${EditInvestmentRoute.EDIT_INVESTMENT_SETTINGS}`,
    `${EditInvestmentRoute.EDIT_INVESTMENT}/${EditInvestmentRoute.INSTRUMENTS_WEIGHTS}`,
    `${EditInvestmentRoute.EDIT_INVESTMENT}/${EditInvestmentRoute.INSTRUMENTS_SELECT}`,
    `${EditInvestmentRoute.EDIT_INVESTMENT}/${EditInvestmentRoute.SUCCESS}`,
  ];

  private isInitialLoad = true;

  public constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.navHomeIfProgressPageReloaded(event.urlAfterRedirects);
        this.clearOnLeaveNewInvestmentProcess(event.urlAfterRedirects);
        this.clearOnLeaveEditInvestmentProcess(event.urlAfterRedirects);
        if (this.isInitialLoad) this.isInitialLoad = false;
      });
  }

  private navHomeIfProgressPageReloaded(currentUrl: string): void {
    const isProgressUrl = [...this.newInvestmentProgressUrls, ...this.editInvestmentProgressUrls]
    .some(url => currentUrl.includes(url));

    if (isProgressUrl && this.isInitialLoad) {
      // progress data will be lost
      this.router.navigate([LOGIN_REDIRECT_PATH]);
    }
  }

  private clearOnLeaveNewInvestmentProcess(currentUrl: string): void {
    if (this.dataService.newInvestmentProgress() && !this.newInvestmentProgressUrls.some(url => currentUrl.includes(url))) {
      this.dataService.clearNewInvestmentProgress();
    }
  }

  private clearOnLeaveEditInvestmentProcess(currentUrl: string): void {
    if (this.dataService.editInvestmentProgress() && !this.editInvestmentProgressUrls.some(url => currentUrl.includes(url))) {
      this.dataService.clearEditInvestmentProgress();
    }
  }

}
